module.exports = __webpack_public_path__ + "img/login-bg.154ed9d5.png";